import { render, staticRenderFns } from "./ClientArea.vue?vue&type=template&id=26d19192&scoped=true"
import script from "./ClientArea.vue?vue&type=script&lang=js"
export * from "./ClientArea.vue?vue&type=script&lang=js"
import style0 from "./ClientArea.vue?vue&type=style&index=0&id=26d19192&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26d19192",
  null
  
)

export default component.exports